// 引入axios
import axios from 'axios'
import router from '@/router'

// axios.defaults.baseURL = 'http://47.101.195.188:8802'

// 设置默认请求头
axios.defaults.headers = {
  // 'Authorization': 'Basic cm9vdDp0YW9zZGF0YQ=='
}
axios.defaults.timeout = 10000

// 设置axios拦截器: 响应拦截器
axios.interceptors.response.use(res => {
  // 成功响应的拦截
  if (res.data.code === 401) {
    router.push('/Login')
  } else {
    return Promise.resolve(res)
  }
})

export default {
  // get请求
  get (url, param, satoken) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        headers: {
          satoken
        },
        url,
        params: param
      }).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // post请求
  post (url, param, satoken) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        headers: {
          satoken
        },
        url,
        data: param
      }).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  download (url, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        responseType: 'arraybuffer',
        headers: {
          satoken: window.localStorage.getItem('capacitance_token')
        },
        url,
        data: params
      }).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/request/uartRequest.js